import React from 'react';

const WhyUs = () => {
  const stats = [
    {
      number: "15+",
      title: "TECRÜBE DOLU YILLAR",
      icon: "/why/quality.png"
    },
    {
      number: "12.000+",
      title: "MEMNUN MÜŞTERİLER",
      icon: "/why/satisfaction.png"
    },
    {
      number: "10+",
      title: "GÜVENİLİR ŞİRKETLER",
      icon: "/why/trust.png"
    },
    {
      number: "DESTEK",
      title: "HER ZAMAN YANINIZDAYIZ",
      icon: "/why/care.png"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-r from-amber-50 to-blue-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold mb-12 text-center">
          Neden <span className="text-blue-500">sigortamolsun.com </span>?
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="bg-white rounded-full w-24 h-24 mx-auto mb-4 flex items-center justify-center shadow-lg">
                <img 
                  src={stat.icon} 
                  alt={stat.title}
                  className="w-16 h-16 object-contain"
                />
              </div>
              <h3 className="text-2xl font-bold mb-2">{stat.number}</h3>
              <p className="text-gray-600 uppercase text-sm tracking-wide">{stat.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;